import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MaterialTable from "material-table";
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { KeyboardDatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";

import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  onSnapshot,
} from "firebase/firestore";

// import {
//   getAllAddressAPICall,
//   getAddress,
//   getZones,
//   getWards,
// } from "../../Address";

import { devicePhaseCode, deviceModeCode, serviceType } from "../../../constants/constants";

import { db, getCheckSession, logout } from "../../../apis/auth";
import DeviceAddressService from "../../../apis/device-address";
import DeviceDataService from "../../../apis/device-data"
import {GetDailyReport} from "../ReportManager" 
import "../../../styles/reports.scss";
import { exportMaterialTableToExcel, exportMaterialTableToPDF, format2Decimals, getDateString, getDateStringHHMMSS } from "../../../utilities/utility";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import PoleDataService from "../../../apis/pole-data";
import { NotificationManager } from "react-notifications";

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

const EnergySavingReport = (props) => {
  // let app = null;
  // let db = null;
  // const firebaseConfigApiResponse = localStorage.getItem(
  //   "firebaseConfigApiResponse"
  // );
  // if (firebaseConfigApiResponse) {
  //   console.log("firebaseConfigApiResponse : ", firebaseConfigApiResponse);
  //   if (!getApps().length) {
  //     app = initializeApp(JSON.parse(firebaseConfigApiResponse));
  //   }
  //   db = getFirestore();
  // }

  const classes = useStyles();
  const history = useHistory();
   const yesterday = new Date();
   yesterday.setDate(yesterday.getDate() - 1);
   const startOfDay = new Date(yesterday);
   startOfDay.setHours(0, 0, 0, 0);  
   const endOfDay = new Date(yesterday);
   endOfDay.setHours(23, 59, 59, 0);   
  const [filterObj, setFilterObj] = useState({
    zone: 0,
    ward: 0,
    ccms: 0,
    startDate: startOfDay,
    endDate: endOfDay,
  });
  const [zoneFilterList, setZoneFilterList] = useState([]);
  const [wardFilterList, setWardFilterList] = useState([]);
  const [ccmsFilterList, setCcmsFilterList] = useState([]);

  const [masterCcmsFilterList, setMasterCcmsFilterList] = useState([]);

  //   const [dashboardReportData, setDashboardReportData] = useState([]);
  const [dashboardReportRawData, setDashboardReportRawData] = useState([]); //TODO: can be removed
  const [opReportData, setOpReportData] = useState([]);

  useEffect( async() => {
    console.log("========== Report : OnInit() ==========");
    var sessionStatus = await getCheckSession();
    if (sessionStatus === false) {
      history.push("/");
      return;
    }

    await DeviceAddressService.getInstance().getAllAddressAPICall();
    await PoleDataService.initService();
    let zoneList = DeviceAddressService.getInstance().getZones();
    let wardList = DeviceAddressService.getInstance().getWards(zoneList[0].value);
    setZoneFilterList(zoneList);
    setWardFilterList(wardList);
    console.log(`==> Zone list ${zoneList}\n\n WardList = ${wardList}`);
    setFilterObj((prevState) => ({
      ...prevState,
      zone: zoneList[0].value,
      ward: wardList[0].value,
    }));

    // setTimeout(() => {
      // getAllDevicesAPICall();
      //   getAllDeviceSummaryAPICall();
      // const treeZoneList = getZones();
      // const zoneList = treeZoneList.map((item) => ({
      //   label: item.value,
      //   value: item.id,
      //   // id: item.id
      // }));
      // console.log("getZones : ", zoneList);
      // setZoneFilterList(zoneList || []);
    // }, 3000);
    
    DeviceDataService.getInstance().initService(onFetchComplete,()=> {
      
    }/*iterateDeviceHandler*/);
  }, []);

  async function onFetchComplete() {
    console.log(`========= EnergySaving : onFetchComplete()`);
    let deviceListIds = await updateDeviceFilterList();
    setFilterObj((prevState) => ({
      ...prevState,
      ccms: deviceListIds[0].value,
    }));
  }

  function iterateDeviceHandler(record, changeType) {
    console.log(`========= EnergySaving : iterateDeviceHandler() =========== record = ${JSON.stringify(record)}`);
    if (record !== null | undefined) {
      if (changeType === "added") {
        let filterRawData = [...ccmsFilterList];
        filterRawData.push(record);
        setCcmsFilterList(filterRawData);
                
      } else if (changeType === "modified") {
        let filterRawData = [...ccmsFilterList];
        var filterIndex = filterRawData.findIndex(item => item.value == record.dev_id);
        filterRawData[filterIndex] = record;
        setCcmsFilterList(filterRawData);

      } else if (changeType === "removed") {
        let filterRawData = [...ccmsFilterList];
        var filterIndex = filterRawData.findIndex(item => item.value == record.dev_id);
        filterRawData.splice(filterIndex, 1);
        setCcmsFilterList(filterRawData);
      }
    }
  }

  async function updateDeviceFilterList(zoneId = 0, wardId = 0, ccms = 0) {
    // const { zoneId: zoneId = 0, wardId: wardId = 0, ccms: ccms = 0 } = filterObj;
    const { deviceListIds:deviceListIds = [], deviceList: deviceList = [], errorDeviceList: errorDeviceList = [] } = await DeviceDataService.getInstance().getDevicesByFilter(zoneId, wardId, ccms);
    setCcmsFilterList(deviceListIds);
    return deviceListIds;
    // setFilterObj((prevState) => ({
    //   ...prevState,
    //   ccms: deviceListIds[0].value,
    // }));
  }

  const getOpReportColumnList = () => {
    return [
      {
        title: 'DATE',
        // field: "date",
        type: "datetime",
        render:({date: date = 'N/A'}) => {
          return date;
        },
        exportTransformer:({date: date = 'N/A'}) => {
          return date;
        },
      },
      {
        title: 'ZONE',
        // field: "zone",
        render:({zn_id: zoneId = 0, zn:zone = ""}) => {
          return zone;
        },
        exportTransformer:({zn_id: zoneId = 0, zn:zone = ""}) => {
          return zone;
        },
      },
      {
        title: 'WARD',
        // field: "ward",
        render:({wd_id: wardId = 0, wd:ward = ""}) => {
          return ward;
        },
        exportTransformer:({wd_id: wardId = 0, wd:ward = ""}) => {
          return ward;
        },
      },
      {
        title: 'SC_NO',
        // field: "sc_no",
        render:({sc_no: sc_no = 'N/A'}) => {
          return sc_no;
        },
        exportTransformer:({sc_no: sc_no = 'N/A'}) => {
          return sc_no;
        },
      },
      {
        title: 'PHONE_NO',
        // field: "sim_no",
        render:({sim_no: sim_no = 'N/A'}) => {
          return sim_no;
        },
        exportTransformer:({sim_no: sim_no = 'N/A'}) => {
          return sim_no;
        },
      },
      {
        title: 'UID',
        // field: "dev_id",
        render:({dev_id: dev_id = 'NA'}) => {
          return dev_id;
        },
        exportTransformer:({dev_id: dev_id = 'NA'}) => {
          return dev_id;
        },
      },
      {
        title: 'LOCATION',
        // field: "location",
        render: (rowData) => {
          let pole = null;
          if (rowData.pid != undefined && rowData.pid != null) {
            pole = PoleDataService.getInstance().getPole(rowData.pid);
          }

          if (pole != null && pole.addr != undefined && pole.addr != null) {
            return pole.addr;
          } else if (rowData.addr != undefined | null | "") {
            return rowData.addr;
          }
          return "N/A"
        },
        exportTransformer:(rowData) => {
          let pole = null;
          if (rowData.pid != undefined && rowData.pid != null) {
            pole = PoleDataService.getInstance().getPole(rowData.pid);
          }

          if (pole != null && pole.addr != undefined && pole.addr != null) {
            return pole.addr;
          } else if (rowData.addr != undefined | null | "") {
            return rowData.addr;
          }
          return "N/A"
        }
        // render:({location: location = 'NA'}) => {
        //   return location;
        // },
        // exportTransformer:({location: location = 'NA'}) => {
        //   return location;
        // },
      },
      {
        title: 'SERVICE TYPE',
        // field: "ctr_ty",
        render:({ctr_ty: ctr_ty = 0}) => {
          return serviceType[ctr_ty];
        },
        exportTransformer:({ctr_ty: ctr_ty = 0}) => {
          return serviceType[ctr_ty];
        },
      },
      {
        title: 'MODE',
        // field: "dev_md",
        render:({dev_md: dev_md = 0}) => {
          if (deviceModeCode[dev_md] === 'Auto') {
            return 'Save';
          } else {
            return 'CAL';
          }
        },
        exportTransformer:({dev_md: dev_md = 0}) => {
          if (deviceModeCode[dev_md] === 'Auto') {
            return 'Save';
          } else {
            return 'CAL';
          }
        },
      },
      {
        title: 'ON TIME',
        // field: "on_time",
        render:({on_time: on_time = 0}) => {
          return getDateStringHHMMSS(on_time);
        },
        exportTransformer:({on_time: on_time = 0}) => {
          return getDateStringHHMMSS(on_time);
        },
      },
      {
        title: 'POWER %',
        // field: "on_time",
        render:({pp: pp = 0}) => {
          return `${(pp * 100).toFixed(2)}`;
        },
        exportTransformer:({pp: pp = 0}) => {
          return `${(pp * 100).toFixed(2)}`;
        },
      },
      {
        title: 'BURN LOAD',
        // field: "bl",
        render:({bl: bl = 0}) => {
          return bl;
        },
        exportTransformer:({bl: bl = 0}) => {
          return bl;
        },
      },
      {
        title: 'BASE WATTS',
        // field: "bw",
        render:({bw: bw = 0}) => {
          return bw;
        },
        exportTransformer:({bw: bw = 0}) => {
          return bw;
        },
      },
      {
        title: 'CORRECTION FACTOR',
        // field: "cf",
        render:({cf: cf = 0}) => {
          return cf;
        },
        exportTransformer:({cf: cf = 0}) => {
          return cf;
        },
      },
      {
        title: 'BASELINE (kWh)',
        // field: "bkwh",
        render:({bkwh: bkwh = 0}) => {
          return bkwh;
        },
        exportTransformer:({bkwh: bkwh = 0}) => {
          return bkwh;
        },
      },
      {
        title: 'ADJUSTED BASELINE (kWh)',
        // field: "abl",
        render:({abl: abl = 0}) => {
          return abl;
        },
        exportTransformer:({abl: abl = 0}) => {
          return abl;
        },
      },
      {
        title: 'ACTUAL CONSUMPTION (kWh)',
        // field: "en_com",
        render:({en_com: en_com = 0}) => {
          return format2Decimals(en_com);
        },
        exportTransformer:({en_com: en_com = 0}) => {
          return format2Decimals(en_com);
        },
      },
      {
        title: 'ENERGY SAVED (kWh)',
        // field: "es",
        render:({es: es = 0}) => {
          return es;
        },
        exportTransformer:({es: es = 0}) => {
          return es;
        },
      },
      {
        title: 'ENERGY SAVING %',
        // field: "esp",
        render:({esp: esp = 0}) => {
          return `${esp}`;
        },
        exportTransformer:({esp: esp = 0}) => {
          return `${esp}`;
        },
      },
      {
        title: 'STATUS',
        // field: "esp",
        render:({status: status = "COM"}) => {
          return `${status}`;
        },
        exportTransformer:({status: status = "COM"}) => {
          return `${status}`;
        },
      },
    ];
  };

  const handleDateChange = (date, dateField) => {
    setFilterObj((prevState) => ({
      ...prevState,
      [dateField]: date,
    }));
  };

  const handleFilterChange = async(e) => {
    const { target: { name = "", value = "" } = {} } = e;
    console.log(`handleFilterChange -> ${name} = ${value}`);
    if (name === "zone") {
      let wardList = DeviceAddressService.getInstance().getWards(value);
      setWardFilterList(wardList);
      
      // // var deviceListIds = dashboardReportRawData
      // //     .filter((item) => item.zn_id === value)
      // //     .map((item) => ({
      // //       label: item.dev_id,
      // //       value: item.dev_id,
      // //     })) || [];

      // let records = dashboardReportRawData.filter((item) => item.zn_id === value) || [];
      // let deviceListIds = [{label: "All",value: 0}]
      // for (let item of records) {
      //   deviceListIds.push({
      //     label: item.dev_id,
      //     value: item.dev_id,
      //   });
      // }
      // setCcmsFilterList(deviceListIds);
      
      let deviceListIds = await updateDeviceFilterList(value, wardList[0].value);
      setFilterObj((prevState) => ({
        ...prevState,
        zone: value,
        ward: wardList[0].value,
        ccms: deviceListIds[0].value,
      }));
    }else if (name === "ward") {
      // const { deviceListIds:deviceListIds = [], deviceList: deviceList = [], errorDeviceList: errorDeviceList = [] } = await DeviceDataService.getInstance().getDevicesByFilter(zone, value);
      // setCcmsFilterList(deviceListIds);
      // let records = dashboardReportRawData.filter((item) => item.zn_id === zone && item.wd_id === value) || [];
      // let deviceListIds = [{label: "All",value: 0}]
      // for (let item of records) {
      //   deviceListIds.push({
      //     label: item.dev_id,
      //     value: item.dev_id,
      //   });
      // }
      // setCcmsFilterList(deviceListIds);
      const { zone: zone = 0} = filterObj;
      let deviceListIds = await updateDeviceFilterList(zone, value);
      setFilterObj((prevState) => ({
        ...prevState,
        ward: value,
        ccms: deviceListIds[0].value,
      }));
    }else if (name === "ccms") {
      setFilterObj((prevState) => ({
        ...prevState,
        ccms: value,
      }));
    }
  };

  const handleFilterApply = async() => {
    const {
      startDate = new Date(),
      endDate = new Date(),
      zone = 0,
      ward = 0,
      ccms = 0,
    } = filterObj;
    startDate.setHours(0,0,0,0);
    endDate.setHours(23,59,59,0);
    const currentDate = new Date();
    currentDate.setHours(23,59,59,0)
    if (startDate > endDate) {
      NotificationManager.error("Please select a valid date range", "", 3000);
      return;
    }
    if (endDate > currentDate) {
      NotificationManager.error("End date cannot be in the future", "", 3000);
      return;
    }
    GetDailyReport(startDate,endDate,zone, ward,ccms).then((reportList) => {
      setOpReportData([...reportList]);
    }).catch((error) => {
      console.log('Energy Saving Report==> ', error.message);
      alert("Unable to complete your request. Please try after sometime.");
    });
    // getAllDeviceSummaryAPICall();
  };

  const getAllDevicesAPICall = async (zoneId = 0, wardId = 0) => {
    let reportList = [];
    let ccmsFilterList = [{label: "All",value: 0}];
    let q = null;
    q = query(collection(db(), "devices"));

    // const q = query(collection(db, "devices"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      
      console.log("users docs : ", doc.data());
      let record = doc.data();
      const {
        dev_id: ccmsNumber = "",
        dev_ml: phase = 0,
        loc: coords = "",
        loc: { _lat: latitude = 0, _long: longitude = 0 } = {},
        dev_st: status = 0,
        errors = [],
        err_cnt: errorsCount = 0,
        dev_md: mode = 0,
        ls: date = "",
        lmp_cnt: lampCount = 0,
        lmp_off_cnt: lampOffCount = 0,
        zn_id: zoneId = 0,
        wd_id: wardId = 0,
        pl_id: placeId = 0,
        st_id: streetId = 0,
      } = record;

      reportList = [...reportList, record];
      ccmsFilterList = [
        ...ccmsFilterList,
        {
          label: ccmsNumber,
          value: ccmsNumber,
        },
      ];
    });
    setDashboardReportRawData([...reportList]);
    setMasterCcmsFilterList([...ccmsFilterList]);
    setCcmsFilterList([...ccmsFilterList]);
  };

  // const getAllDeviceSummaryAPICall = async (zoneId = 0, wardId = 0) => {
  //   let reportList = [];
  //   let summary_query = null;
  //   const {
  //     startDate = new Date(),
  //     endDate = new Date(),
  //     zone = 0,
  //     ward = 0,
  //     ccms = 0,
  //   } = filterObj;
  //   startDate.setHours(0,0,0,0);
  //   if (zone === 0) {
  //     if (ward === 0) {
  //       if (ccms === 0) {
  //         summary_query = query(
  //           collection(db(), "daily_summ"),
  //           where("dt", ">=", startDate),
  //           where("dt", "<=", endDate),
  //           orderBy("dt", "asc"),
  //           orderBy("dev_id", "asc")
  //         );
  //       } else {
  //         summary_query = query(
  //           collection(db(), "daily_summ"),
  //           where("dt", ">=", startDate),
  //           where("dt", "<=", endDate),
  //           where("dev_id", "==", ccms),
  //           orderBy("dt", "asc"),
  //           // orderBy("dev_id", "asc")
  //         );
  //       }
  //     } else {
  //       if (ccms === 0) {
  //         summary_query = query(
  //           collection(db(), "daily_summ"),
  //           where("dt", ">=", startDate),
  //           where("dt", "<=", endDate),
  //           where("wd_id", "==", ward),
  //           orderBy("dt", "asc"),
  //           orderBy("dev_id", "asc")
  //         );
  //       } else {
  //         summary_query = query(
  //           collection(db(), "daily_summ"),
  //           where("dt", ">=", startDate),
  //           where("dt", "<=", endDate),
  //           where("wd_id", "==", ward),
  //           where("dev_id", "==", ccms),
  //           orderBy("dt", "asc"),
  //           // orderBy("dev_id", "asc")
  //         );
  //       }
  //     }
  //   } else {
  //     if (ward === 0) {
  //       if (ccms === 0) {
  //         summary_query = query(
  //           collection(db(), "daily_summ"),
  //           where("dt", ">=", startDate),
  //           where("dt", "<=", endDate),
  //           where("zn_id", "==", zone),
  //           orderBy("dt", "asc"),
  //           orderBy("dev_id", "asc")
  //         );
  //       } else {
  //         summary_query = query(
  //           collection(db(), "daily_summ"),
  //           where("dt", ">=", startDate),
  //           where("dt", "<=", endDate),
  //           where("zn_id", "==", zone),
  //           where("dev_id", "==", ccms),
  //           orderBy("dt", "asc"),
  //           // orderBy("dev_id", "asc")
  //         );
  //       }
  //     } else {
  //       if (ccms === 0) {
  //         summary_query = query(
  //           collection(db(), "daily_summ"),
  //           where("dt", ">=", startDate),
  //           where("dt", "<=", endDate),
  //           where("zn_id", "==", zone),
  //           where("wd_id", "==", ward),
  //           orderBy("dt", "asc"),
  //           orderBy("dev_id", "asc")
  //         );
  //       } else {
  //         summary_query = query(
  //           collection(db(), "daily_summ"),
  //           where("dt", ">=", startDate),
  //           where("dt", "<=", endDate),
  //           where("zn_id", "==", zone),
  //           where("wd_id", "==", ward),
  //           where("dev_id", "==", ccms),
  //           orderBy("dt", "asc")
  //         );
  //       }
  //     }
  //   }

  //   // const q = query(collection(db, "devices"));
  //   // const querySnapshot = await getDocs(summary_query);
  //   // onSnapshot(summary_query, (querySnapshot) => {
  //   await getDocs(summary_query).then((querySnapshot) => {
  //     querySnapshot.forEach((doc) => {
  //       console.log("users docs : ", doc.data());
  //       let record = doc.data();
  //       const {
  //         dev_id: ccmsNumber = "",
  //         dt: date = "",
  //         en_con: energyConsumption,
  //         rs_at: autoModeRunTime,
  //         rs_bp: byPassModeRunTime,
  //         rs_ex: expectedRunTime,
  //         rs_mn: manualModeRunTime,
  //         // wd_id: wardId,
  //         // zn_id: zoneId,
  //       } = record;
  
  //       // date
  //       let transformedDate = "";
  //       if (date?.seconds) {
  //         transformedDate = format(new Date(date.seconds * 1000), "dd/MM/yyyy");
  //       }
  
  //       // Uptime and Percent of upTime
  //       const totalUpSecs =
  //         autoModeRunTime + byPassModeRunTime + manualModeRunTime; // secs
  //       const totalUpHours = new Date(totalUpSecs * 1000)
  //         .toISOString()
  //         .substring(11, 16);
  //       const totalUpTimePercent = (
  //         (totalUpSecs / expectedRunTime) *
  //         100
  //       ).toFixed(2);
  //       const autoModeHours = new Date(autoModeRunTime * 1000)
  //         .toISOString()
  //         .substring(11, 16);
  //       const manualModeHours = new Date(manualModeRunTime * 1000)
  //         .toISOString()
  //         .substring(11, 16);
  //       const byPassModeHours = new Date(byPassModeRunTime * 1000)
  //         .toISOString()
  //         .substring(11, 16);
  
  //       // let upHoursElem = (
  //       //   <>
  //       //     <div>{totalUpHours}</div>
  //       //     <div>{`(${autoModeHours} A + ${manualModeHours} M + ${byPassModeHours} B)`}</div>
  //       //   </>
  //       // );
  //       let transformedUpHours = "";
  //       if (autoModeHours === "00:00" && manualModeHours === "00:00") {
  //         transformedUpHours = `${totalUpHours} B`;
  //       } else if (manualModeHours === "00:00" && byPassModeHours === "00:00") {
  //         transformedUpHours = `${totalUpHours} A`;
  //       } else if (autoModeHours === "00:00" && byPassModeHours === "00:00") {
  //         transformedUpHours = `${totalUpHours} M`;
  //       } else if (autoModeHours === "00:00") {
  //         transformedUpHours = `${totalUpHours} (${manualModeHours} M + ${byPassModeHours} B)`;
  //       } else if (manualModeHours === "00:00") {
  //         transformedUpHours = `${totalUpHours} (${autoModeHours} A + ${byPassModeHours} B)`;
  //       } else if (byPassModeHours === "00:00") {
  //         transformedUpHours = `${totalUpHours} (${autoModeHours} A + ${manualModeHours} M)`;
  //       } else {
  //         transformedUpHours = `${totalUpHours} (${autoModeHours} A + ${manualModeHours} M + ${byPassModeHours} B)`;
  //       }
  
  //       reportList = [
  //         ...reportList,
  //         {
  //           date: transformedDate,
  //           ccmsNumber,
  //           //   zoneId,
  //           //   wardId,
  //           // location: `${zone},${ward}`
  //           // dev_md
  //           // dev_ml
  //           upHours: transformedUpHours,
  //           // upHours: upHoursElem,
  //           upHoursPercent: `${totalUpTimePercent} %`,
  //           energyConsumption,
  //         },
  //       ];
      
  //     });
  //   }).catch((error)=>{
  //     console.log(`====> Error fetch : ${error}`);
  //   }); 
   
  // // });
  

  //   // Combined report
  //   reportList = reportList.map((reportItem) => {
  //     const matchedItem = dashboardReportRawData.find(
  //       ({ dev_id: ccmsNumber }) => ccmsNumber === reportItem.ccmsNumber
  //     );
  //     if (matchedItem) {
  //       const {
  //         zn_id: zoneId = 0,
  //         wd_id: wardId = 0,
  //         pl_id: placeId = 0,
  //         st_id: streetId = 0,
  //         dev_md: mode = 0,
  //         dev_ml: phase = 0,
  //       } = matchedItem;
  //       // zone, ward
  //       const {
  //         zone = "",
  //         ward = "",
  //         place = "",
  //         street = "",
  //       } = DeviceAddressService.getInstance().getAddress(zoneId, wardId, placeId, streetId);
  //       return {
  //         ...reportItem,
  //         zone,
  //         ward,
  //         location: `${place},${street}`,
  //         mode,
  //         phase,
  //       };
  //     }
  //     return {
  //       ...reportItem,
  //       location: "",
  //       mode: 0,
  //       phase: 0,
  //     };
  //   });
  //   setOpReportData([...reportList]);
  // };

  // useEffect(async () => {
  //   // getAllAddressAPICall(db);

  //   setTimeout(() => {
  //     getAllDevicesAPICall();
  //     //   getAllDeviceSummaryAPICall();
  //     const treeZoneList = getZones();
  //     const zoneList = treeZoneList.map((item) => ({
  //       label: item.value,
  //       value: item.id,
  //       // id: item.id
  //     }));
  //     console.log("getZones : ", zoneList);
  //     setZoneFilterList(zoneList || []);
  //   }, 3000);
  // }, []);

  const {
    startDate = new Date(),
    endDate = new Date(),
    zone: zoneFilter = 0,
    ward: wardFilter = 0,
    ccms: ccmsFilter = 0,
  } = filterObj;

  return (
    <div className="reports">
      <h2 className="reports-header">Energy Saving Report</h2>
      <Grid container className="reports-filter-wrapper">
        {/* <Grid xs={12} sm={3} className="reports-date-filter">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              clearable
              autoOk
              label="Start Date"
              value={startDate}
              placeholder="dd/MM/yyyy"
              InputAdornmentProps={{ position: "end" }}
              onChange={(date) => handleDateChange(date, "startDate")}
              variant="inline"
              inputVariant="outlined"
              // minDate={new Date()}
              format="dd/MM/yyyy"
            />
          </MuiPickersUtilsProvider>
        </Grid> */}
        {/* <Grid xs={12} sm={3} className="reports-date-filter">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              clearable
              autoOk
              label="End Date"
              value={endDate}
              placeholder="dd/MM/yyyy"
              InputAdornmentProps={{ position: "end" }}
              onChange={(date) => handleDateChange(date, "endDate")}
              variant="inline"
              inputVariant="outlined"
              // minDate={new Date()}
              format="dd/MM/yyyy"
            />
          </MuiPickersUtilsProvider>
        </Grid> */}
        <Grid xs={12} sm={12}>
          <div className="reports-zw-filter">
          <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              clearable
              autoOk
              label="Start Date"
              value={startDate}
              placeholder="dd/MM/yyyy"
              InputAdornmentProps={{ position: "end" }}
              onChange={(date) => handleDateChange(date, "startDate")}
              variant="inline"
              inputVariant="outlined"
              // minDate={new Date()}
              format="dd/MM/yyyy"
            />
          </MuiPickersUtilsProvider>
          </FormControl>
          <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              clearable
              autoOk
              label="End Date"
              value={endDate}
              placeholder="dd/MM/yyyy"
              InputAdornmentProps={{ position: "end" }}
              onChange={(date) => handleDateChange(date, "endDate")}
              variant="inline"
              inputVariant="outlined"
              // minDate={new Date()}
              format="dd/MM/yyyy"
            />
          </MuiPickersUtilsProvider>
          </FormControl>
            <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <InputLabel id="zone-label">Zone</InputLabel>
              <Select
                labelId="zone-label"
                id="zone-outlined"
                name="zone"
                value={zoneFilter}
                onChange={handleFilterChange}
                label="Zone"
              >
                {zoneFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <InputLabel id="ward-label">Ward</InputLabel>
              <Select
                labelId="ward-label"
                id="ward-outlined"
                name="ward"
                value={wardFilter}
                onChange={handleFilterChange}
                label="Ward"
              >
                {wardFilterList.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <InputLabel id="ccms-label">UID</InputLabel>
              <Select
                labelId="ccms-label"
                id="ccms-outlined"
                name="ccms"
                value={ccmsFilter}
                onChange={handleFilterChange}
                label="UID"
              >
                {ccmsFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              className="ml-auto reports-apply-btn"
              onClick={handleFilterApply}
            >
              Apply
            </Button>
          </div>
        </Grid>
      </Grid>

      <div className="dashboard-table">
        <MaterialTable
          style={{
            margin: "20px 0",
            width: "100%",
          }}
          className={classes.table}
          title=""
          columns={getOpReportColumnList()}
          data={opReportData}
          onRowClick={(evt, rowData) => {
            console.log("row click", evt, rowData);
            // setSelectedRowData(rowData);
            // setIsErrorDialogOpen(true);
          }}
          options={{
            exportButton: true,
              exportAllData:true,
              exportCsv:(columns, csvData) => {exportMaterialTableToExcel(columns, csvData, `Energy Saving Report-${getDateString()}`);},
              exportPdf:(columns, csvData) => {exportMaterialTableToPDF(columns, csvData, `Energy Saving Report-${getDateString()}`, 8, 18);},
              // exportCsv: (columns, data) => ExportCsv(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`,","),
              // exportPdf: (columns, data) => ExportPdf(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`),
            // grouping: true,
            search: true,
            selection: false,
            sorting: true,
            pageSize: 10,
            // rowStyle: (rowData) => ({
            //   backgroundColor:
            //     rowData?.ccmsNumber === selectedRowData?.ccmsNumber
            //       ? "#f0f2f4"
            //       : "",
            // }),
            headerStyle: {
              backgroundColor: "#0071CE",
              color: "#FFF",
              fontSize: "0.9em",
              textAlign: "center",
            },
            actionsColumnIndex: -1,
            emptyRowsWhenPaging: false,
          }}
          localization={{
            toolbar: {
              searchPlaceholder: "Search",
              exportCSVName: "Export as Excel",
              exportPDFName: "Export as PDF",
            },
          }}
        />
      </div>
    </div>
  );
};
export default EnergySavingReport;
